import datapoints from './datapoints';
import onAfterSelectingNode from './helpers/onAfterSelectingNode';
import selectDefaultFolder from './selectDefaultFolder';
import selectNodeInFolderForest from './selectNodeInFolderForest';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getStore as getSharedFavoritesStore, convertFavoritePersonaDataToFavoritePersonaNode, } from 'owa-favorites';
import folderStore from 'owa-folders';
import { isFavoritingInProgress, lazyOnFavoritePersonaSelected } from 'owa-mail-favorites-store';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { addFrequentlyUsedFolder } from 'owa-mail-frequently-used-folders';
import { wasFolderPrefetched } from 'owa-mail-frequently-used-folders';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { action } from 'satcheljs/lib/legacy';
/**
 * Select a persona node
 * @param personaId the folderId
 * @return a promise that resolves when the load persona table from server has completed
 */
export default action('selectPersona', datapoints.selectPersona)(function selectPersona(favoriteId) {
    var selectNodePromise;
    // Only perform the rest of selecting folder logic when
    // user navigates to a folder with the different folderId
    if (favoriteId != getSelectedNode().id) {
        var roamingApiEnabled = isControlFeatureEnabled('tri-favorites-roaming');
        var personaNode = void 0;
        if (roamingApiEnabled) {
            var data = getSharedFavoritesStore().outlookFavoritePersonas.get(favoriteId);
            personaNode = convertFavoritePersonaDataToFavoritePersonaNode(data);
        }
        else {
            personaNode = getSharedFavoritesStore().favoritesPersonaNodes.get(favoriteId);
        }
        if (!personaNode) {
            selectDefaultFolder();
            return Promise.resolve();
        }
        var isAddingInProgress = isFavoritingInProgress(personaNode.mainEmailAddress);
        var searchFolderNotFound = false;
        // If the search folder for this persona was not found and adding is not in progress, fallback to search
        // A new search folder will be generate further along this codepath
        if (!isAddingInProgress && !folderStore.folderTable.has(personaNode.searchFolderId)) {
            searchFolderNotFound = true;
            personaNode.searchFolderId = undefined;
            personaNode.isSearchFolderPopulated = false;
        }
        var willUseSearchFallback = !personaNode.isSearchFolderPopulated;
        var isPrefetchedFuf = personaNode.searchFolderId && wasFolderPrefetched(personaNode.searchFolderId);
        var selectPersonaDatapoint = returnTopExecutingActionDatapoint();
        // Datapoint is not present for unit tests
        if (selectPersonaDatapoint) {
            selectPersonaDatapoint.addCustomData({
                isSearchFallback: willUseSearchFallback,
                searchFolderNotFound: searchFolderNotFound,
                isPrefetchedFuf: !!isPrefetchedFuf,
            });
        }
        selectNodePromise = selectNodeInFolderForest(personaNode, 'FavoritesPersonaNode');
        if (!roamingApiEnabled) {
            lazyOnFavoritePersonaSelected.importAndExecute(personaNode.id);
        }
        if (personaNode.searchFolderId) {
            addFrequentlyUsedFolder(personaNode.searchFolderId);
        }
    }
    // Called after selecting same/different persona
    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
    onAfterSelectingNode();
    return selectNodePromise;
});
//# sourceMappingURL=selectPersona.js.map